import { FadeIn } from "@/components/Reveal";

export default function LegalPage({ title, updated, sections, testid }) {
  return (
    <div data-testid={testid}>
      <section className="bg-paper pt-44 pb-28 lg:pb-36">
        <div className="mx-auto max-w-[1600px] px-6 lg:px-12 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-3">
            <FadeIn>
              <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-brand">
                Legal
              </p>
              <p className="mt-4 font-mono text-[11px] tracking-[0.18em] uppercase text-slateblue">
                Last updated: {updated}
              </p>
            </FadeIn>
          </div>
          <div className="md:col-span-8 md:col-start-5">
            <FadeIn>
              <h1 className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">
                {title}
              </h1>
            </FadeIn>
            <div className="mt-14 space-y-12">
              {sections.map((section, i) => (
                <FadeIn key={i} delay={i * 0.03}>
                  <div data-testid={`${testid}-section-${i + 1}`}>
                    <h2 className="font-display text-xl sm:text-2xl text-ink">
                      <span className="font-mono text-sm text-slateblue mr-3">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {section.h}
                    </h2>
                    <div className="mt-4 space-y-4 max-w-2xl">
                      {section.paras.map((para, j) => (
                        <p key={j} className="text-sm sm:text-base leading-relaxed text-ink/65">
                          {para}
                        </p>
                      ))}
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
